import React from 'react';
import { usePageContext } from 'Context/PageContext';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { getSearchMappedTypeForLabelGA } from 'Tracking/utils';
type Payload = {
  categoryGA: string;
  actionGA: string;
  labelGA: string;
  internalSearchEngineNbResults: string;
  searchReferrer: string;
  searchRequestType: 'Autocomplete' | 'Nocomplete';
  searchTerms: string;
};
export const useTrackQueryChange = () => {
  const pageContext = usePageContext();
  const track = useTracking();

  const executeTracking = (query?: SearchQuery, payload?: Partial<Payload>) => {
    if (query) {
      const isFromAutoComplete = Boolean(query.type);
      track({
        categoryGA: pageContext.pageId,
        actionGA: 'search',
        labelGA: getSearchMappedTypeForLabelGA(query.type),
        internalSearchEngineNbResults: '',
        searchReferrer: pageContext.pageId,
        searchRequestType: isFromAutoComplete ? 'Autocomplete' : 'Nocomplete',
        searchTerms: query.label || null,
        ...payload,
      });
    }
  };

  return executeTracking;
};
